import React from 'react';

import * as S from './styled';
import { InputProps } from './styled'

type Mask = string[] | { (): void };

interface BaseProps {
  id?: string;
  type?: string;
  placeholder?: string;
  mask?: Mask;
  inputRef: React.RefObject<HTMLInputElement | null>;
}

type Props = BaseProps & InputProps & React.ComponentType<'input'>

const TextInput = ({
  mask,
  type = 'text',
  inputRef,
  ...rest
}: Props) => (mask ? (
  <S.Masked
    ref={inputRef}
    type={type}
    mask={mask}
    {...rest}
  />
) : (
  <S.Input
    ref={inputRef}
    type={type}
    {...rest}
  />
));

export default TextInput;
